import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} data
 */
export const list = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMessage.List',
    data
  })
}

/**
 * 消息已读
 * @param {*} data
 */
export const read = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMessage.Read',
    data
  })
}

/**
 * 未读数量
 * @param {*} data
 */
export const unreadCount = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMessage.UnreadCount',
    data
  })
}

/**
 * 删除消息
 * @param {*} data
 */
export const del = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMessage.Delete',
    data
  })
}

/**
 * 获取动态
 * @param {*} data
 */
export const getDynamic = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMessage.GetDynamic',
    data
  })
}